import { Box, FormHelperText, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useState, useEffect } from 'react';
import OtpInput, { InputProps } from 'react-otp-input';
import { maskMobileNumber } from '../../utils/utilityFunctions';
import { useDispatch } from 'react-redux';
import { getInvestorJointHolderDetails, getInvestorTokenCompany, getRoleBasedPermissions, getUserInfo, newVerifyLoginOtp, showError, verifyLoginOtp } from '../../redux-store/actions/auth';
import { useHistory } from 'react-router';
import { LoginLayout, OtpTimer } from '../commonComponents';
import { getInvestorTokenWithCompany, getOtpForInvestor, getOtpForPaymentFlow, verifyOtpForInvestor, verifyOtpForPayment } from '../../redux-store/actions/onBoarding';
import { Location } from 'history';
import { loginWithOtp } from '../../redux-store/actions/auth';
import {
  GetInvestorJointHolderDetailsResponseBody,
  GetInvestorTokenCompanyResponseBody,
  GetOtpForInvestorResponse,
  GetRoleBasedPermissionsResponseBody,
  LoginWithOtpResponseBody,
  verifyInvestorResponse,
  VerifyLoginOtpResponseBody,
  VerifyPaymentResponse,
} from '../../redux-store/types/api-types';
import { Formik } from 'formik';
import { MFSubmitButton } from '../../lib/formik';
import { GET_USER_INFO_SUCCESS, LOGOUT_SUCCESS, VERIFY_LOGIN_OTP, VERIFY_LOGIN_OTP_SUCCESS } from '../../redux-store/types/auth';
import { USER_ROLES } from '../../utils/constant';
import { storeApplicationId, storeInterfaceCode, storeInvestorClientId, storeIwappId } from '../../redux-store/actions/id';
import { setInvestorRmId } from '../../redux-store/actions/sessionData';

const intialValues: { OTP: string } = {
  OTP: '',
};

export default function LoginOtp({
  location,
}: {
  location: Location<{
    mobile: string;
    phone: string;
    email: string;
    verificationToken: string;
    loginType: string;
    referenceId: string;
    countryCode: string;
    otpRefNo: string;
    numberOfOTPTries: number;
  }>;
}): JSX.Element {
  const {
    mobile = '',
    loginType = '',
    referenceId,
    countryCode = '+91',
    phone = '',
    email = '',
  } = location.state || {};
  const dispatch = useDispatch();
  const history = useHistory();
  const [error, setError] = useState<string>('');
  const [{ verificationToken, otpRefNo, numberOfOTPTries }, setVerifyOtpInfo] = useState({ verificationToken: '', otpRefNo: '', numberOfOTPTries: 0 });
  const [isLoading, setLoading] = useState<boolean>(false)

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'));
  const isSm = useMediaQuery(theme.breakpoints.up('sm'));
  const isXs = useMediaQuery(theme.breakpoints.up('xs'));

  const handleSubmit = async (values: { OTP: string }, { resetForm }: { resetForm: () => void }) => {

    const { OTP } = values;
    try {
      setLoading(true)

      if (!OTP || OTP.length !== 6) {
        setError('Enter OTP');
        return;
      }

      if (loginType === 'payment') {
        try {
          const paymentRes = await (dispatch(verifyOtpForPayment(referenceId, { otp: OTP, verificationToken, otpRefNo })) as unknown) as VerifyPaymentResponse;
          if (paymentRes?.token) {
            const payload = {
              clientCode: paymentRes?.clientCode
            }
            const tokenWithCompanyRes = await (dispatch(getInvestorTokenWithCompany(payload)) as unknown) as verifyInvestorResponse
            if (tokenWithCompanyRes?.token) {
              history.push('payment-details', {
                clientCode: paymentRes?.clientCode,
                portfolioId: paymentRes?.portfolioId
              })
            }
          }
        }
        catch (e) {
          console.log(e);
        };
        return;
      }
      if (loginType === 'investor') {
        const res = await dispatch(verifyOtpForInvestor(referenceId, { otp: OTP, verificationToken, otpRefNo }) as unknown as Promise<verifyInvestorResponse>);
        if (res?.token) {
          await dispatch(getUserInfo());
          history.push(`application-details`);
          return;
        }
      }
      const res = await (dispatch(newVerifyLoginOtp({ phone: mobile, otp: OTP, verificationToken, countryCode, otpRefNo })) as unknown) as VerifyLoginOtpResponseBody
      // const res = await (dispatch(verifyLoginOtp({ phone: mobile, otp: OTP, verificationToken, countryCode })) as unknown) as VerifyLoginOtpResponseBody
      if (!res) {
        return
      }
      if (!res?.role) {
        history.push('select-role', {
          ...res,
        })

        return;
      }

      if (res?.role === 'investor' && loginType === '') {
        // const jointHolder = await fetch(`api/onboarding/dashboard/getInvestorDetails`, {
        //   method: 'GET',
        //   headers: {
        //     Accept: "application/json",
        //     "Content-Type": "application/json",
        //     Expires: '0',
        //     Authorization: "Bearer " + (res.token || '') as string
        //   },
        // }).then(async (res) => {
        //   if (!res.ok) {
        //     const errorBody = await res.json();
        //     throw errorBody;
        //   }
        //   return res.json();
        // }).catch((e) => {
        //   dispatch(showError(e?.message));
        // });

        const jointHolder = await dispatch(getInvestorJointHolderDetails({
          temporaryToken: res.token
        }) as unknown as Promise<GetInvestorJointHolderDetailsResponseBody>)

        if (jointHolder.isSuccess) {
          if (jointHolder?.data?.accountList?.length === 1) {
            dispatch(storeInvestorClientId({ investorClientId: jointHolder?.data?.accountList[0]?.clientCode }));
            dispatch(storeInterfaceCode(jointHolder?.data?.accountList[0]?.clientInterfaceCode ?? jointHolder?.data?.accountList[0]?.clientCode));
            dispatch(storeIwappId({ iwappRmId: jointHolder?.data?.accountList[0]?.rmId ?? "" }));
            dispatch(setInvestorRmId(jointHolder?.data?.accountList[0]?.rmId ?? ''));

            const showDiyInvOnboardingPrev = (res?.role === USER_ROLES.INVESTOR) && ['sent_to_amc_approver', 'consent_sent_to_applicants'].includes(`${jointHolder?.data?.accountList?.[0]?.status ?? ''}`?.toLowerCase() as string);

            const isKycDone = jointHolder?.data?.accountList?.[0]?.kycMethod !== 'investor';

            const showDiyInvestorOnboarding = (res?.role === USER_ROLES.INVESTOR) && ['sent_to_investor'].includes(`${jointHolder?.data?.accountList?.[0]?.status ?? ''}`?.toLowerCase() as string);

            const individualSelected = `${jointHolder?.data?.accountList?.[0]?.accountType ?? ''}`.toLowerCase() === 'individual account'
            const nonIndividualSelected = `${jointHolder?.data?.accountList?.[0]?.accountType ?? ''}`.toLowerCase() === 'non-individual account'
            const jointSelected = `${jointHolder?.data?.accountList?.[0]?.accountType ?? ''}`.toLowerCase() === 'joint account'

            // const tokenWithCompanyRes = await fetch(`api/users/users/generate-investor-token-with-company`, {
            //   method: 'POST',
            //   headers: {
            //     Accept: "application/json",
            //     "Content-Type": "application/json",
            //     Expires: '0',
            //     Authorization: "Bearer " + (res?.token || '') as string
            //   },
            //   body: JSON.stringify({ clientCode: jointHolder?.data?.accountList?.[0]?.clientCode, applicationId: jointHolder?.data?.accountList?.[0]?.id })
            // }).then((res) => res.json());

            const tokenWithCompanyRes = await dispatch(getInvestorTokenCompany({
              clientCode: jointHolder?.data?.accountList?.[0]?.clientCode,
              applicationId: jointHolder?.data?.accountList?.[0]?.id,
              temporaryToken: res.token
            }) as unknown as Promise<GetInvestorTokenCompanyResponseBody>)


            if (tokenWithCompanyRes.isSuccess) {
              const permissionResponse = await dispatch(getRoleBasedPermissions({
                temporaryToken: tokenWithCompanyRes?.token ?? ""
              }) as unknown as Promise<GetRoleBasedPermissionsResponseBody>)
              if (!permissionResponse) return;
              dispatch(storeApplicationId({ applicationId: jointHolder?.data?.accountList?.[0]?.id }))
              dispatch({
                type: VERIFY_LOGIN_OTP_SUCCESS,
                body: {
                  ...tokenWithCompanyRes,
                  diyAccountType: `${jointHolder?.data?.accountList?.[0]?.accountType ?? ''}`.toLowerCase(),
                  diyIsKycDone: isKycDone,
                  diyInvestorOnboardingEdit: showDiyInvestorOnboarding,
                  diyInvOnboardingPrev: showDiyInvOnboardingPrev,
                  permissions: permissionResponse?.permissions[`${tokenWithCompanyRes?.role ?? ""}`.toLowerCase()] ?? permissionResponse?.permissions[`${tokenWithCompanyRes?.role ?? ""}`.toUpperCase()] ?? []
                }
              })

              if (individualSelected && !isKycDone) {
                history.replace(`/kyc-doc-selection`, { id: jointHolder?.data?.accountList?.[0]?.id });
                return;
              } else if (individualSelected && showDiyInvestorOnboarding) {
                dispatch(showError('Please complete your Onboarding'));
                history.replace(`/investor-onboarding-application/personal-details`, { id: jointHolder?.data?.accountList?.[0]?.id });
                return;
              } else if (((individualSelected || jointSelected) && showDiyInvOnboardingPrev)) {
                history.replace(`/investor-onboarding-application-details/${jointHolder?.data?.accountList?.[0]?.id}`, { id: jointHolder?.data?.accountList?.[0]?.id });
                return;
              } else if (nonIndividualSelected && showDiyInvOnboardingPrev) {
                history.replace(`/non-individual-application-preview/${jointHolder?.data?.accountList?.[0]?.id}`, { id: jointHolder?.data?.accountList?.[0]?.id });
                return;
              }
            }

          } else {

            history.push('joint-holder', {
              ...res,
              jointHolderData: jointHolder.data.accountList

            })
          }
        }
      } else {
        const permissionsSelectionCriteria = res?.subRole ? res?.subRole : res?.role;

        const permissionResponse = await dispatch(getRoleBasedPermissions({
          temporaryToken: res?.token ?? ""
        }) as unknown as Promise<GetRoleBasedPermissionsResponseBody>);

        if (!permissionResponse) return;
        dispatch({
          type: VERIFY_LOGIN_OTP_SUCCESS,
          body: {
            ...res,
            permissions: permissionResponse?.permissions[`${permissionsSelectionCriteria ?? ""}`.toUpperCase()] ?? permissionResponse?.permissions[`${permissionsSelectionCriteria ?? ""}`.toLowerCase()] ?? permissionResponse?.permissions[permissionsSelectionCriteria] ?? []
          }
        });
      }

    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setLoading(false)
      resetForm();
    }
  };

  useEffect(() => {
    const { verificationToken, otpRefNo, numberOfOTPTries } = location.state || {};
    if (!location.state) {
      history.push('/login');
    }
    setVerifyOtpInfo({ verificationToken, otpRefNo, numberOfOTPTries });
  }, []);

  const onResend = async () => {
    try {
      setLoading(true)
      if (loginType === 'payment') {
        const response = (await dispatch(
          getOtpForPaymentFlow(referenceId)
        )) as unknown as GetOtpForInvestorResponse;
        setVerifyOtpInfo({ ...response });
        return;
      }
      if (loginType === 'investor') {
        const response = (await dispatch(
          getOtpForInvestor(referenceId)
        )) as unknown as GetOtpForInvestorResponse;
        setVerifyOtpInfo({ ...response });
        return;
      }
      const res = (await dispatch(
        loginWithOtp({ phone: mobile, countryCode })
      )) as unknown as LoginWithOtpResponseBody;
      setVerifyOtpInfo({ ...res });
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setLoading(false)
    }
  };

  return (
    <LoginLayout LoginText="Login with OTP">
      <Formik initialValues={intialValues} onSubmit={handleSubmit}>
        {({ values, setValues, handleSubmit }) => (
          <Box component="form" noValidate onSubmit={handleSubmit}>
            <Typography sx={{ color: 'primary.main', textAlign: 'center', mb: 3.5 }}>
              An OTP has been sent to your mobile number
              <Typography component="span">{` ${phone} `}</Typography>
              {email && (
                <Typography component="span">
                  and email Id{' '}
                  <Typography component="span" sx={{ wordBreak: 'break-all' }}>
                    {' '}
                    {email}
                  </Typography>
                </Typography>
              )}
            </Typography>
            <Box
              sx={{
                mb: 0,
                '.otp-input': {
                  input: {
                    width: { xs: '37px !important', md: '45px !important' },
                    fontSize: { xs: '20px !important', md: '30px !important' },
                    margin: { xs: '2px !important', md: '4px !important' },
                  },
                },
              }}>
              <OtpInput
                inputType='number'
                renderInput={(inputProps: InputProps) => <input {...inputProps} type='password' style={{ ...inputProps.style }} disabled={isLoading} />}
                value={values.OTP}
                // isDisabled={isLoading}
                onChange={(OTP: string) => setValues({ OTP })}
                numInputs={6}
                // hasErrored={!!error}
                // isInputNum={true}
                // isInputSecure={true}
                shouldAutoFocus={true}
                containerStyle={{
                  display: 'flex',
                  justifyContent: 'center',
                  // flexWrap: 'wrap',
                }}
                inputStyle={{
                  width: !isSm ? '35px' : !isMd ? '40px' : '45px',
                  height: !isSm ? '35px' : !isMd ? '40px' : '45px',
                  // padding: '5px 10px',
                  // // width: '45px',
                  borderRadius: '5px',
                  fontSize: !isSm ? '22px' : '30px',
                  borderColor: error ? `${theme.palette.common.red}` : `${theme.palette.text.primary}`,
                  color: error ? `${theme.palette.common.red}` : `${theme.palette.text.primary}`,
                  outline: 'none'
                }}
                renderSeparator={() => (
                  <span style={{ width: '6px' }}></span>
                )}

              // errorStyle={{ border: '2px solid red', color: 'red' }}
              // focusStyle={{ outline: 'none' }}
              // className="otp-input"
              />
              {!!error && (
                <FormHelperText error sx={{ mt: 2, textAlign: 'center', fontSize: '14px' }}>
                  {error}
                </FormHelperText>
              )}
            </Box>
            <Box
              sx={{
                '.MuiTypography-root, .MuiButton-root': {
                  textAlign: 'center',
                },
              }}>
              <OtpTimer onResend={onResend} numberOfOTPTries={numberOfOTPTries} />
            </Box>
            <Box
              sx={{
                fontSize: 14,
                color: 'red',
                textAlign: 'center',
                // marginBottom: -2,
                marginBottom: 2
              }}>
              {/* Note: User Account will be locked after 3 unsuccessful attempts, Resend otp can be
              requested 2 times for every hour */}
              {/* Note: You can request up to two SMS OTPs and one Voice OTP per hour. */}
              Note: You can request up to three SMS OTPs per hour.
            </Box>
            <Box sx={{ textAlign: 'center' }}>
              <MFSubmitButton label="Submit" loadingEnable={isLoading} />
            </Box>
          </Box>
        )}
      </Formik>
    </LoginLayout>
  );
}
